import React, { useState, useImperativeHandle } from 'react'
import styled from '@emotion/styled'
import showImg from './assets/show.png'
import deleteImg from './assets/delete.png'

const Item = styled.div`
  font-size: 0.75rem;
  border-bottom: solid 1px rgba(0, 0, 0, 0.08);
  &:hover {
    color: #0056fe;
  }
  &:hover .close-btn {
    visibility: visible !important;
  }
  &:focus {
    background: rgba(0, 86, 254, 0.1);
  }
`

const GeoList = ({
  geos,
  currentGeoIndex,
  updateCurrentGeo,
  deleteGeo,
  geosRef,
}) => {
  const [isShowList, setIsShowList] = useState(false)

  useImperativeHandle(geosRef, () => ({
    returnFileds: () => {
      return geos
    },
  }))

  return (
    <div>
      {!isShowList ? (
        <div
          className="h-full flex items-center justify-center"
          style={{
            width: '1.25rem',
            height: '25rem',
            background: 'rgba(245,245,245,1)',
            borderRadius: '0.1rem',
          }}
          onClick={() => {
            setIsShowList(true)
          }}
        >
          <img src={showImg} alt="" className="w-4 h-4 cursor-pointer" />
        </div>
      ) : (
        <div
          className="w-full"
          style={{
            height: '25rem',
            boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.08)',
            borderRadius: '0.1875rem',
            background: '#fff',
            color: '#555',
          }}
        >
          <div
            className="w-full flex flex-row items-center font-semibold"
            style={{
              height: '2.625rem',
              fontSize: '0.75rem',
              borderBottom: 'solid 1px rgba(0,0,0,0.08)',
            }}
          >
            <div className="w-1/4 flex items-center justify-center">序号</div>
            <div className="w-3/4 flex items-center justify-between">
              点位名称
              <div
                onClick={() => {
                  setIsShowList(false)
                }}
              >
                <img
                  style={{
                    marginRight: '0.625rem',
                    width: '0.6875rem',
                    height: '0.6875rem',
                  }}
                  src={showImg}
                  alt=""
                  className="cursor-pointer float-right"
                />
              </div>
            </div>
          </div>
          <div
            className="w-full overflow-y-auto"
            style={{ height: 'calc(100% - 2.625rem)' }}
          >
            {(geos || []).map((item, index) => {
              return (
                <Item
                  key={index}
                  className="w-full flex flex-row items-center cursor-pointer focus:bg-gray-50"
                  onClick={() => {
                    updateCurrentGeo(item.geo)
                  }}
                  style={{
                    background: `${
                      currentGeoIndex && index + 1 === currentGeoIndex.index
                        ? 'rgba(0, 86, 254, 0.1)'
                        : 'unset'
                    }`,
                    color: `${
                      currentGeoIndex && index + 1 === currentGeoIndex.index
                        ? '#0056fe'
                        : '#555'
                    }`,
                  }}
                >
                  <div className="w-1/4 flex items-center justify-center">
                    {index + 1}
                  </div>
                  <div className="w-3/4 flex items-center justify-between">
                    <span className="w-5/6">{item.address}</span>
                    {currentGeoIndex && index + 1 === currentGeoIndex.index && (
                      <a
                        onClick={() => {
                          deleteGeo(currentGeoIndex)
                        }}
                      >
                        <img
                          src={deleteImg}
                          className="w-4 h-4"
                          alt=""
                          style={{ marginRight: '0.625rem' }}
                        />
                      </a>
                    )}
                  </div>
                </Item>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default GeoList
